import {
	DeploymentEnvironmentTypeOptions,
	type EnvironmentTypeViewConfiguration,
	type DeploymentEnvironmentType,
} from '../types';

export const toEnvironmentTypeFilter = (
	configuration: EnvironmentTypeViewConfiguration,
): DeploymentEnvironmentType[] => {
	const areAllEnvironmentTypesSelected = Object.values(configuration).every(
		(isSelected) => isSelected,
	);
	if (areAllEnvironmentTypesSelected) {
		return [];
	}
	const { production, staging, development, testing, unmapped } = configuration;
	return [
		...(production ? [DeploymentEnvironmentTypeOptions.PRODUCTION] : []),
		...(staging ? [DeploymentEnvironmentTypeOptions.STAGING] : []),
		...(development ? [DeploymentEnvironmentTypeOptions.DEVELOPMENT] : []),
		...(testing ? [DeploymentEnvironmentTypeOptions.TESTING] : []),
		...(unmapped ? [DeploymentEnvironmentTypeOptions.UNMAPPED] : []),
	];
};
